var map = {
	"./archive-details/archive-details.html": 1756,
	"./archive-details/components/static-confirmation-workflow/static-confirmation-workflow.html": 1757,
	"./archive-details/components/static-invoice-information/static-invoice-information.html": 1758,
	"./archive-details/components/static-invoice-rows/static-invoice-rows.html": 1759,
	"./archive-details/components/static-invoice-slider/static-invoice-slider.html": 1760,
	"./archive-details/components/static-related-documents/static-related-documents.html": 1761,
	"./archive-details/components/static-transaction-rows/static-transaction-rows.html": 1762,
	"./archive-register/archive-register.html": 1763,
	"./archive-register/components/archive-register-filter/archive-register-filter.html": 1764,
	"./archive-register/components/archive-register-table/archive-register-table.html": 1765,
	"./detailed-transactions/components/detailed-transactions-table-footer/detailed-transactions-table-footer.html": 1766,
	"./detailed-transactions/components/detailed-transactions-table-header/detailed-transactions-table-header.html": 1767,
	"./detailed-transactions/components/detailed-transactions-table/detailed-transactions-table.html": 1768,
	"./detailed-transactions/detailed-transactions.html": 1769,
	"./invoice-register/invoice-register.html": 1770,
	"./side-menus/components/mobile-side-menu/ds-mobile-side-menu.tpl.html": 1771,
	"./side-menus/ds-side-menus.tpl.html": 1772
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1755;